import { createRoutine } from "redux-saga-routines";

export const getHlsConfigRoutine = createRoutine('GET_HLS_CONFIG');